import React from 'react';
import {
  MenuItem,
  TextField
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';

const theme = createTheme({
    palette: {
      type: 'dark',
    },
  });

const ImageSourceSelection = ({ classes, value, imageSources, onChange }) => {
  return (
    <ThemeProvider theme={theme}>
      <div className={classes.container}>
        <TextField
          variant='outlined'
          select
          value={value}
          onChange={onChange}
        >
          {imageSources.map((el, index) => <MenuItem key={index} value={el.source}>{`${el.source} (${el.images.length})`}</MenuItem>)}
        </TextField>
      </div>
    </ThemeProvider>
  )
}

const styles = theme => ({
  container: {
    zIndex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    borderRadius: 4
  }
});

export default withStyles(styles)(ImageSourceSelection);